function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaperplaneright(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    viewBox: "0 0 24 25",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M20.948 10.94L5.112 2.072a1.5 1.5 0 00-2.145 1.813L5.686 11.5h7.064a.75.75 0 010 1.5H5.686l-2.72 7.613a1.504 1.504 0 001.41 2.007c.258 0 .512-.067.736-.193l15.836-8.868a1.501 1.501 0 000-2.618z",
    fill: props.fill
  }));
}

export default SvgPaperplaneright;